export default function UsersApi( api ) {
  
  const connect = api.child( 'v1/user' )

  function forgotPassword( username, projectId ) {
    return connect.child( 'forgotPassword' ).post( { username, projectId } )
  }

  return {
    list : connect.get,
    create : connect.post, 
    forgotPassword, 
    resetPassword : connect.child( 'resetPassword' ).post,
    child : connect.child
  }
}
